<template>
  <div
    @click="$emit('click')"
    :class="getClass()">

    <div class='text-container'>
      <p v-if="first" class='sub'>{{ first }}</p>
      <p v-if="main" class='main'>{{ main }} </p>
      <p v-if="second" class='sub'>{{ second }}</p>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CardButton',
  props: {
    first: String,
    main: String,
    second: String,

    positive: Boolean,
    error: Boolean,
    primary: Boolean,
    tertiary: Boolean,
    secondary: Boolean,

    light: Boolean,
    disabled: Boolean,

    darkGray: Boolean
  },

  methods: {
    getClass () {
      let result = 'card-button ';
      if (this.positive) result += 'positive-aev';
      else if (this.error) result += 'error-aev';
      else if (this.secondary) result += 'secondary-aev';
      else if (this.primary) result += 'secondary-aev';
      else if (this.tertiary) result += 'tertiary-aev';
      else if (this.darkGray) result += 'dark-gray-aev';
      else result += 'secondary-aev';

      if (this.light) result += ' light';

      if (this.disabled) result = 'card-button disabled';
      return result;
    }
  }
};
</script>

<style lang='scss' scoped>
  @import "../../utils/assets/stylesheets/variables.scss";

  .card-button {
    position: relative;
    width: 100%;
    cursor: pointer;
    border-radius: $border-radius;
    line-height: 1.5em;
    min-height: 150px;
    padding: 17px;

    .text-container {
      position: absolute;
      bottom: 17px;
    }

    background-color: $secondary-lighten-4;
    .sub {
      color: $secondary-darken-1;
    }

    .main {
      color: $quinary;
      font-weight: 700;
      font-size: 1.2em;
    }

    &:hover {
      background-color: lighten($secondary-lighten-4, 2%);
    }

    &.positive-aev {
      background-color: $positive;
      .sub { color: $positive-lighten-2; }
      .main { color: white; font-weight: 600; }

      &:hover {
        background-color: lighten($positive, 2%);
      }

      &.light {
        background-color: $positive-lighten-3;
        .sub { color: $positive-darken-1; }
        .main { color: $quinary; font-weight: 700; }

        &:hover {
          background-color: lighten($positive-lighten-3, 2%);
        }
      }
    }

    &.error-aev {
      background-color: $error;
      .sub { color: $error-lighten-2; }
      .main { color: white; font-weight: 600; }

      &:hover {
        background-color: lighten($error, 2%);
      }

      &.light {
        background-color: $error-lighten-4;
        .sub { color: $error-darken-1; }
        .main { color: $quinary; font-weight: 700; }

        &:hover {
          background-color: lighten($error-lighten-4, 2%);
        }
      }
    }

    &.tertiary-aev {
      background-color: $tertiary;
      .sub { color: $tertiary-lighten-3; }
      .main { color: white; font-weight: 600; }
      &:hover {
        background-color: lighten(#f3bb00, 2%);
      }
      &.light {
        background-color: $tertiary-lighten-3;
        .sub { color: $tertiary-darken-1; }
        .main { color: $quinary; font-weight: 700; }

        &:hover {
          background-color: lighten($tertiary-lighten-3, 2%);
        }
      }
    }

    &.secondary-aev {
      background-color: $secondary;
      .sub  { color: $secondary-lighten-2; }
      .main { color: white; font-weight: 600; }

      &:hover {
        background-color: lighten($secondary, 2%);
      }

      &.light {
        background-color: $secondary-lighten-4;
        .sub { color: $secondary; }
        .main { color: $quinary; font-weight: 700; }

        &:hover {
          background-color: lighten($secondary-lighten-4, 2%);
        }
      }
    }

    &.dark-gray-aev {
      background-color: $primary-darken-1;
      .sub  { color: $primary-lighten-2; }
      .main { color: white; font-weight: 700; }

      &:hover {
        background-color: lighten($primary-darken-1, 4%);
      }
    }

    &.disabled {
      background-color: $gray-lighten-2;
      .sub { color: $primary-lighten-1; }
      .main { color: $primary; font-weight: 700; }

      &:hover{
        background-color: lighten($gray-lighten-2, 2%);
      }
    }
  }
</style>
